import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IRecipientNotification  } from "../../services/admin-report-data-service/Models";
import AdminReportDataService from "../../services/admin-report-data-service/AdminReportDataService";

export type UseAvailableRecipientsToNotifyForUserParams = {
    contextGroupID: number,
} & BaseUseQueryParameters<IRecipientNotification[] | undefined>;

export function useAvailableRecipientsToNotifyForUser({
    contextGroupID,
    enabled,    
    onSuccess,
    onError
}: UseAvailableRecipientsToNotifyForUserParams) {
    return useQuery<IRecipientNotification[], RestError>(
        keys.availableRecipientsToNotifyForUser(contextGroupID),
        ({ signal }) => {
            return AdminReportDataService.getAvailableRecipientsForUser(
                contextGroupID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchOnMount: true,
            refetchInterval: false,
            staleTime: Infinity,
        }
    );
}